<template>
  <div>
    <el-card class="add-product-info-header" shadow="nerver">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>附加项</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="add-product-info-content" shadow="nerver">
      <!-- 附加项名称 -->
      <div class="content-line" style="display: flex">
        <div class="content-title">附加项名称：</div>
        <div class="content-input">
          <el-input
            size="mini"
            v-model="input"
            placeholder="请输入产品标题"
          ></el-input>
        </div>
      </div>
      <!-- 附加项说明 -->
      <!-- 附加项底价 -->
      <!-- 附加项售价 -->
      <!-- 附加项说明 -->
    </el-card>
  </div>
</template>

<script>
export default {
  name: "addtional",
  data() {
    return {
      input: "",
    };
  },
};
</script>

<style>
</style>